<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Preferred Branch
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      p.card-text Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, necessitatibus iste facere sunt! Blanditiis consequuntur odio autem sit delectus doloribus repudiandae laborum, officiis incidunt illo quam ratione, vero iusto praesentium.
      ValidationObserver(ref="Validation" slim)
        ValidationProvider(ref="Provider" name="branch" rules="required" v-slot="{errors}" slim)
          .row
            .col-12(v-if="errors.length > 0")
              .alert.alert-danger {{errors[0]}}
            .col-md-4.mb-3(v-for="(coop, index) in coops", :key="index")
              .card
                .card-body.text-center
                  h5.card-title {{coop.name}}
                  p.card-text {{coop.address}}
                  button.btn.btn-block.btn-sm(type="button", :class="{'btn-outline-primary': (value!=coop.id), 'btn-primary': (value==coop.id)}" @click.prevent="select(coop)") SELECT
          //- .custom-control.custom-checkbox
            input.custom-control-input#agreement(type="checkbox")
            label.custom-control-label(for="agreement") Lorem ipsum dolor, sit amet, consectetur adipisicing elit. Quidem asperiores voluptatum iure laborum, ducimus dolore eaque doloremque vel repellendus eius et illum repudiandae nam vero ab amet, soluta cumque fuga?
</template>

<style scoped=""></style>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  name: 'Branch',

  props: {
    value: {
      type: Number,
      required: false,
    },
    coops: {
      type: Array,
      required: true,
    },
  },

  emits: ['input', 'prev', 'onSelectBranch'],

  setup(props, { emit }) {
    const Validation = ref(null);
    const Provider = ref(null);
    const selectedBranchField = ref(null);

    const validate = () => {
      return Validation.value.validate().then((success) => {
        if (success) {
          return Promise.resolve(success);
        }
        return Promise.reject(success);
      });
    };
    const select = (coop) => {
      emit('input', coop.id);
      emit('onSelectBranch', coop);
    };
    watch(
      () => props.value,
      (newVal) => {
        selectedBranchField.value = newVal;
        Provider.value.validate(newVal);
      }
    );
    const prev = () => {
      emit('prev');
    };
    const next = () => {
      emit('next');
    };

    return {
      prev,
      next,
      selectedBranchField,
      select,
      Provider,
      Validation,
      validate,
    };
  },
};
</script>
